

import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '~/store/modules/user';

@Component
export default class TopText extends Vue {
    get userMail(): string {
        return UserModule.userMail;
    }
}
